import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ImageGallery.css';

interface ImageGalleryProps {
  images?: string[];
  autoSlide?: boolean;
  slideInterval?: number;
}

const CustomImageGallery: React.FC<ImageGalleryProps> = ({
  images = ['/1.jpg', '/2.jpg', '/3.jpg', '/4.jpg', '/5.jpg'],
  autoSlide = true,
  slideInterval = 4000,
}) => {
  // Transform image URLs to the format expected by react-image-gallery
  const galleryImages = images.map((image, index) => ({
    original: image,
    thumbnail: image,
  }));

  return (
    <div className="w-full h-full">
      <ImageGallery
        items={galleryImages}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={true}
        showNav={true}
        autoPlay={autoSlide}
        slideInterval={slideInterval}
        slideDuration={450}
        thumbnailPosition="bottom"
        useBrowserFullscreen={false}
        lazyLoad={true}
        showIndex={true}
        indexSeparator=" / "
        additionalClass="custom-gallery"
      />
    </div>
  );
};

export default CustomImageGallery;
